import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const SuccessHeader = ({ registrationId, userName }) => {
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowConfetti(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  const confettiVariants = {
    initial: { opacity: 0, y: -20, scale: 0 },
    animate: { 
      opacity: 1, 
      y: 0, 
      scale: 1,
      transition: { 
        duration: 0.6,
        ease: "easeOut"
      }
    },
    exit: { 
      opacity: 0, 
      scale: 0.8,
      transition: { duration: 0.4 }
    }
  };

  const iconVariants = {
    initial: { scale: 0, rotate: -180 },
    animate: { 
      scale: 1, 
      rotate: 0,
      transition: { 
        type: "spring",
        stiffness: 200,
        damping: 15,
        delay: 0.2
      }
    }
  };

  return (
    <div className="relative bg-gradient-to-br from-success/10 via-primary/5 to-accent/10 border border-success/20 rounded-xl p-6 md:p-8 mb-8">
      {/* Confetti Animation */}
      {showConfetti && (
        <div className="absolute inset-0 overflow-hidden rounded-xl pointer-events-none">
          {[...Array(12)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-2 h-2 bg-success rounded-full"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
              }}
              variants={confettiVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ delay: i * 0.1 }}
            />
          ))}
        </div>
      )}

      <div className="relative z-10 text-center">
        {/* Success Icon */}
        <motion.div
          className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-success rounded-full mx-auto mb-4"
          variants={iconVariants}
          initial="initial"
          animate="animate"
        >
          <Icon name="CheckCircle" size={32} color="white" strokeWidth={2} />
        </motion.div>

        {/* Success Message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground mb-2">
            Registration Successful!
          </h1>
          <p className="text-lg md:text-xl text-text-secondary mb-4 mt-5">
            Welcome to Solvarsity, {userName}!
          </p>
          <p className="text-sm md:text-base text-text-secondary max-w-2xl mx-auto">
            Your registration has been completed successfully. You're now enrolled in our comprehensive training program.
          </p>
        </motion.div>

        {/* Registration ID */}
        { registrationId ?
          <motion.div
          className="mt-6 p-4 bg-surface border border-border rounded-lg inline-block"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          <p className="text-sm font-medium text-text-secondary mb-1">
            Your Registration ID
          </p>
          <div className="flex items-center space-x-2">
            <span className="text-lg md:text-xl font-mono font-bold text-primary">
              {registrationId}
            </span>
            <button
              onClick={() => navigator.clipboard.writeText(registrationId)}
              className="flex items-center justify-center w-8 h-8 bg-primary/10 hover:bg-primary/20 text-primary rounded-md transition-smooth"
              title="Copy Registration ID"
            >
              <Icon name="Copy" size={16} strokeWidth={2} />
            </button>
          </div>
        </motion.div> : <></>
        }
        
      </div>
    </div>
  );
};

export default SuccessHeader;